import styled from "styled-components";
import { StyledInputHolderMd } from "../Input";

export const CharacterCount = styled.div`
  margin-bottom: 25px;
`;

export const StyledInputHolder = styled(StyledInputHolderMd)`
  margin-bottom: 10px;
`;
